const initialState = {
  resultsNavigationList: [],
  resultsNavigation: {},
  navigationUpdateResponse: null,
  resultsNavigationDelete: {},
  navigationAddResponse: {},
  navigationEditResponse: {}
}


const reducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case "GET_LIST_NAVIGATION":
    case "GET_NAVIGATION":
    case "ADD_NAVIGATION":
    case "EDIT_NAVIGATION":
    case "DELETE_NAVIGATION":
      newState.loading = true
      break

    case "LIST_NAVIGATION_RESPONSE_GET":
      newState.resultsNavigationList = action.value
      newState.loading = false
      break

    case "PRODUCT_NAVIGATION_RESPONSE_GET":
      newState.resultsNavigation = action.value
      newState.loading = false
      break

    case "NAVIGATION_RESPONSE_UPDATE":
      return {
        ...state,
        loading: false,
        navigationUpdateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null,
      }

    case "NAVIGATION_RESPONSE_EDIT":
      newState.navigationEditResponse = action.value
      newState.resultsNavigationList = action.value
      newState.loading = false
      break

    case "RESET_NAVIGATION_RESPONSES":
      return {
        ...state,
        resultsNavigationList: [],
        navigationUpdateResponse: null,
        resultsNavigationDelete: {},
        resultsNavigation: {},
        navigationAddResponse: {},
        navigationEditResponse: {},
        error: null,
      }

    case "NAVIGATION_RESPONSE_DELETE":
      newState.resultsNavigationDelete = action.value;
      break;
    case "NAVIGATION_RESPONSE_ADD":
      newState.navigationAddResponse = action.value;
      break;



    case "CLEAR_NAVIGATION":
      return {
        ...state,
        resultsNavigation: null,
      }
    default:
      break
  }
  return newState
}

export default reducer